import { Select, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { useStores } from "../../store/store_context";
import { observer } from "mobx-react-lite";

const SelectGroupByOrders = observer(() => {
  const { pageStore } = useStores();
  return (
    <VStack>
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        width={"300px"}
        value={pageStore.selected_view_orders}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedViewOrders(selectedValue);
        }}
      >
        <option value="all" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Полностью</option>
        <option value="manager" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджеры</option>
        <option value="org" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Организации</option>
        <option value="partner" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты</option>
        <option value="departament" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>ОП с РОПом</option>
        <option value="departament-withoutROP" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>ОП без РОПа</option>
      </Select>
    </VStack>
  );
})

export default SelectGroupByOrders;
